import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/siteData';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-site">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选文章
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            汇集金学研究的优秀成果，从多维度解读这部经典名著的文学价值与思想深度
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featured.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/category/renwu-jiexi"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-primary-600 border border-primary-300 rounded-md hover:bg-primary-50 transition-colors duration-200"
          >
            查看全部文章
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}